/** Normaliza para comparar transcrições consecutivas (Chrome/Android reemite a mesma frase ou uma versão estendida). */
export const normalizeSpeechTranscriptForDedupe = (s: string): string =>
  s.replace(/\s+/g, ' ').trim().toLowerCase()

/**
 * Detecta se `next` é duplicata ou extensão redundante de `prev` (evita concatenar duas vezes o mesmo ditado).
 */
export function isOverlappingOrDuplicateTranscript(prev: string, next: string): boolean {
  const a = normalizeSpeechTranscriptForDedupe(prev)
  const b = normalizeSpeechTranscriptForDedupe(next)
  if (!a || !b) return false
  if (a === b) return true
  if (b.startsWith(a) || a.startsWith(b)) return true
  const wordsA = a.split(' ')
  if (wordsA.length >= 2) {
    const tail = wordsA.slice(-Math.min(8, wordsA.length)).join(' ')
    if (tail.length >= 12 && b.includes(tail)) return true
  }
  return false
}
